// @ts-nocheck
import Editor from '../../../../Editor/Editor';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import { TripDetailedDayPropTypes } from '../types';
import { formatDateWithAddedDayUTC } from '../../../../../utils/dateUtility';
import { useTranslation } from 'react-i18next';
import { getLastListItem } from '../../../../../utils/common';
import { getOldCoverImageUrl } from '../../../../../utils/getCoverImageUrl';
import './DaySection.css';

const DaySection = ({
  date,
  daynumber,
  title,
  description,
  note,
  tenantSettings,
  children,
  ...data
}) => {
  const { i18n } = useTranslation('common');
  const { bodyfont, headingfont, color: highlightColor } = tenantSettings;
  const dayDate = formatDateWithAddedDayUTC(date, daynumber - 1, i18n.language);
  const coverImage = getLastListItem(data.tripdayimage || []);
  const displayNote = false;
  const hideImagesInPdf = tenantSettings?.showImagesInPdf === false;
  const hasContent = title || description || note || coverImage;

  return (
    <Box className='day-section' fontFamily={bodyfont}>
      <Box className='day-section__title-content'>
        <Box className='day-section__date-badge'>
          <label
            className='day-section__badge'
            style={{
              backgroundColor: highlightColor
            }}
          >{`Day ${daynumber}`}</label>
          <Typography
            className='day-section__date'
            style={{
              fontFamily: headingfont
            }}
          >
            {dayDate}
          </Typography>
        </Box>
        {hasContent && (
          <Box className='day-section__content'>
            {title && (
              <Typography
                variant='h4'
                fontWeight='bold'
                className='day-section__title'
                style={{
                  fontFamily: headingfont
                }}
              >
                {title}
              </Typography>
            )}
            {coverImage && coverImage.imageurl && (
              <div
                className={`header__image ${hideImagesInPdf ? 'noprint' : ''}`}
              >
                <img
                  src={getOldCoverImageUrl(coverImage?.imageurl)}
                  alt={data.tripname}
                />
              </div>
            )}
            {description && (
              <Editor
                id={`day-section__description-${daynumber}-${date}`}
                content={description}
                editable={false}
                isPreviewing={true}
                className='day-section__description'
                style={{
                  fontFamily: bodyfont,
                  fontSize: '12px' // Standardized to the same value as the travel-doc
                }}
              />
            )}
            {note && displayNote && (
              <Editor
                id={`day-section__note-${daynumber}-${date}`}
                content={note}
                editable={false}
                isPreviewing={true}
                className='day-section__note'
                style={{
                  fontFamily: bodyfont,
                  fontSize: '12px' // Standardized to the same value as the travel-doc
                }}
              />
            )}
          </Box>
        )}
      </Box>
      {children}
    </Box>
  );
};

DaySection.propTypes = {
  ...TripDetailedDayPropTypes,
  date: PropTypes.any,
  tenant: PropTypes.shape({
    tenantlogo: PropTypes.string,
    tenantphone: PropTypes.string,
    tenantname: PropTypes.string,
    tenanturl: PropTypes.string
  }),
  tenantSettings: PropTypes.shape({
    bodyfont: PropTypes.string,
    color: PropTypes.string,
    headingfont: PropTypes.string,
    name: PropTypes.string,
    showImagesInPdf: PropTypes.bool,
    showOperatorInfo: PropTypes.bool
  })
};

export default DaySection;
